import {
  Box,
  Checkbox,
  Dialog,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Stack
} from "@mui/material";
import { region } from "../../config/images";
import "./Region.css";
import { useState, useEffect } from "react";
import { deleteStateList, getStateList, updateStateList } from "../../config/services";
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";

const StateTable = ({ stateData, regionData, setStateUpdated,
  stateCurrentPage,
  setStateCurrentPage,
  stateCount,
  perPage
 }) => {
  const [editStatePopup, setEditStatepopup] = useState(false);
  const [deleteStatePopup, setDeleteStatePopup] = useState(false);
  const [regionName, setRegionName] = useState();
  const [stateName, setStateName] = useState();
  const [stateId, setStateId] = useState();
  const [loading, setLoading] = useState(false);

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const handleOpenEditDialog = (e) => {
    setRegionName(e.region); // get the id of the region to show in the update form 
    setStateName(e.state_name);
    setStateId(e.id);
    setEditStatepopup(true)
  };

  const handleEditState = async (e) => {
    e.preventDefault()
    try {
      setLoading(true);
      const params = {
        region: regionName,
        state_name: stateName
      }
      const resp = await updateStateList(stateId, params);

      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setEditStatepopup(false);
        setStateUpdated(true); //   ✅ Trigger state refresh
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      notify(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const handleOpenDeleteDialog = async (id) => {
    setDeleteStatePopup(true)
    setStateId(id);
  };

  const handleDeleteState = async (e) => {
    e.preventDefault()
    try {
      setLoading(true);
      const resp = await deleteStateList(stateId);
      if (resp.data) {
        notifySuccess(resp.data.message)
      }
      setDeleteStatePopup(false);
      setStateUpdated(true); //   ✅ Trigger state refresh
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.log("error")
      notify(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));


  const handlePageChange = (event, value) => {
    setStateCurrentPage(value);
  };
console.log("sdjkdufj", stateCurrentPage)
  return (
    <>
      <Table className="region-table ">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "50px" }}>
            <Checkbox
                      sx={{
                        color: "rgba(225, 230, 244, 1)",
                        borderRadius: "4px",
                        "&.Mui-checked": {
                          color: "rgba(199, 206, 227,1)",
                        },
                      }}
                    />
            </TableCell>
            <TableCell style={{ width: "100px" }}>Sr.No</TableCell>
            <TableCell style={{ width: "200px" }}>Region Name</TableCell>
            <TableCell>State Name</TableCell>
            <TableCell style={{ width: "100px" }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stateData.map((e, i) => {
            return (
              <TableRow>
                <TableCell>
                <Checkbox
                      sx={{
                        color: "rgba(225, 230, 244, 1)",
                        borderRadius: "4px",
                        "&.Mui-checked": {
                          color: "rgba(199, 206, 227,1)",
                        },
                      }}
                    />
                </TableCell>
                {/* <TableCell>{i + 1}</TableCell> */}
                <TableCell style={{ textAlign: "center" }}>{i + 1 + (stateCurrentPage - 1) * perPage}</TableCell>
                <TableCell>{e.region_name}</TableCell>
                <TableCell>{e.state_name}</TableCell>
                <TableCell>
                  <div className="d-flex gap-3">
                    <img
                      src={region.editIcon}
                      alt=""
                      style={{ cursor: "pointer", height: "23px" }}
                      onClick={() => handleOpenEditDialog(e)}
                    />
                    <img src={region.deleteIcon} alt="" style={{ cursor: "pointer" }}
                      onClick={() => handleOpenDeleteDialog(e.id)} />
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Box display="flex" justifyContent="end" alignItems="center">
                <Stack spacing={2} className="mb-2">
                  <CustomPagination
                    count={Math.ceil(stateCount / perPage)}
                    page={stateCurrentPage}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </Stack>
              </Box>
      <Dialog
        open={editStatePopup}
        // onClose={() => setEditStatepopup(false)}
        maxWidth="xs"
        fullWidth
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <div className="assign-div">
          {" "}
          <div className="d-flex justify-content-around align-items-center">
            <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
              Update State
            </h5>
          </div>
        </div>
        <DialogContent>
          <form noValidate autoComplete="off">
            <FormControl fullWidth className="mb-3">
              <InputLabel>Select Region</InputLabel>
              <Select
                label="Select Region"
                name="region"
                value={regionName}
                onChange={(e) => setRegionName(e.target.value)}
              >
                {regionData.map((item, index) => (
                  <MenuItem value={item.id}>{item.region_name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label="Enter State"
              name="taskTitle"
              value={stateName}
              onChange={(e) => setStateName(e.target.value)}
              className="mb-3"
            />

            <div className="d-flex gap-3 mt-2">
              <button
                className="cancel-button"
                onClick={(e) => { e.preventDefault(); setEditStatepopup(false) }}
              >
                Cancel
              </button>
              <button
                className="assign-task-button"
                onClick={(e) => handleEditState(e)}
                disabled={loading}
              >
                {loading ? <span className="spinner"></span> : "Update State"}
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={deleteStatePopup}
        // onClose={() => setDeleteStatePopup(false)}
        maxWidth="xs"
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}

      >
        <DialogContent className="p-5" style={{ textAlign: "center" }}>
          <Box>
            <img src={region.correct} alt="" />
          </Box>
          <Typography variant="h5" className="pt-4 mb-2">
            <b>Delete this category </b>
          </Typography>
          <Typography variant="p" className="pt-4" style={{ fontSize: "16px" }}>
            Are you sure you want to <br />
            delete this category{" "}
          </Typography>
          <div className="d-flex gap-3 pt-4">
            <button
              className="assign-task-button"
              onClick={(e) => handleDeleteState(e)}
              disabled={loading}
            >
              {loading ? <span className="spinner"></span> : "Yes"}
            </button>
            <button
              className="assign-task-button"
              onClick={() => setDeleteStatePopup(false)}
            >
              No
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default StateTable;
